import { createSelector } from 'reselect'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import { searchItemsSectionUtil } from 'modules/section/utils/search-items'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import { getObjectUtil } from 'packages/src'
import { getSearchDomainListSectionSelector } from 'modules/section/selectors/getSearchDomainList/index.js'

/**
 * Search items based on the given section and query (from the store).
 * @param  {string} section
 */
function getSearchedItemsSectionSelector (section) {
  return createSelector(
    state => state[getDomainPathFromSectionReduxUtil(section)],
    (state, props) => getObjectUtil(props, 'match.params.category'),
    getQuerySearchSelect,
    getSearchDomainListSectionSelector({ section }),
    (
      domain,
      category,
      query,
      domainList
    ) => searchItemsSectionUtil({
      domain,
      category,
      section,
      query,
      domainList
    })
  )
}

export {
  getSearchedItemsSectionSelector
}
